import React, { useState, useRef } from "react";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import footer__logo from "../../Assests/r1.jpg";
import { Row, Col } from "react-bootstrap";
import "./Footer_contact_tab.css";
import TranslationFile from "../15-Translation/locale/Translation_apps.json";
import config from "../../Configuration/Config";
import axios from "axios";
let userSelectedLanguage;

export default function Footer_contact_tab(props) {
  userSelectedLanguage = localStorage.getItem("selectedLanguage");
  const scriptURL =
    "https://script.google.com/macros/s/AKfycbyLuamRvfdsObvyflCqewspaYhzK1NXWYJekui7pGWdXD8lTQU4gbcUPwoCar4vbJln/exec";
  const toast = useRef(null);

  const [isCorpPortal, setIsCorpPortal] = useState(true);
  const [isHomePage, setIsHomePage] = useState(true);
  const [newsLetterEmail, setNewsLetterEmail] = useState("");

  const [isLoading, setIsLoading] = useState(false);
  // const handleSubmit = async (e) => {
  //   setIsLoading(true);
  //   e.preventDefault();
  //   const response = await fetch(scriptURL, {
  //     method: "POST",
  //     body: new FormData(e.target),
  //   });

  //   if (response.ok) {
  //     setIsLoading(false);
  //     toast.current.show({
  //       severity: "success",
  //       summary: TranslationFile.SuccessText[userSelectedLanguage],
  //       detail: TranslationFile.ThankForSubscribing[userSelectedLanguage],
  //       sticky: true,
  //     });
  //     setTimeout(() => {
  //       e.target.reset();
  //     }, 2000);
  //     setTimeout(() => {
  //       toast.current.clear();
  //     }, 5000);
  //   }
  // };

  const handleSubmit = async (e) => {
    setIsLoading(true);
    e.preventDefault();
    const encodedEmail = encodeURIComponent(newsLetterEmail);
    axios
      .post("/NewsLetter/insertEmailId?emailId=" + encodedEmail)
      .then((response) => {
        if (response.data == "success") {
          toast.current.show({
            severity: "success",
            summary: TranslationFile.SuccessText[userSelectedLanguage],
            detail: TranslationFile.ThankForSubscribing[userSelectedLanguage],
            sticky: true
          });
        } else if (response.data == "subscribed already") {
          toast.current.show({
            severity: "success",
            summary: TranslationFile.SuccessText[userSelectedLanguage],
            detail: TranslationFile.SubscribedAlready[userSelectedLanguage],
            sticky: true
          });
        }
      });
    setIsLoading(false);
    setNewsLetterEmail("");
  };

  return (
    <footer
      // className="footer-main-div"
      className={
        props.sideBar == undefined || !props.sideBar
          ? "footer-main-div"
          : "footer-main-div-sidebar"
      }
    >
      <div className="footer-image-div">
        <center>
          <img
            alt
            src={footer__logo}
            className="footer_Logo_image"
            width="300px"
          />
        </center>
      </div>
      <div className="footer-list-div">
        <div className="footer-list-div-1">
          <center>
            <div className="footer_title1">
              {TranslationFile.FooterOnlineServices[userSelectedLanguage]}
            </div>
            <section className="footerSection">
              <li>
                <a
                  className="footer--bottom_sub"
                  href="/annualreport"
                  target="_blank"
                >
                  {/* annualReport */}
                  <center>
                    {TranslationFile.FooterAnnualReport[userSelectedLanguage]}
                  </center>
                </a>
              </li>
              <li>
                <a
                  className="footer--bottom_sub"
                  // href={config.apps.url + "SRU_IncomeDeclaration"}
                  href={config.SRU.url}
                  target="_blank"
                >
                  {/* Income Declaration */}
                  <center>
                    {
                      TranslationFile.FooterIncomeDeclaration[
                        userSelectedLanguage
                      ]
                    }
                  </center>
                </a>
              </li>
              <li>
                <a
                  className="footer--bottom_sub"
                  // href="/for-accounting-companies/"
                  href={config.corporatePage.url + "for-accounting-companies"}
                  target="_blank"
                >
                  <center>
                    {
                      TranslationFile.FooterForAccountingCompany[
                        userSelectedLanguage
                      ]
                    }
                  </center>
                </a>
              </li>
              <li>
                <a
                  className="footer--bottom_sub"
                  // href="/microsoft-business-central-development/"
                  href={
                    config.corporatePage.url +
                    "microsoft-business-central-development"
                  }
                  target="_blank"
                >
                  <center>
                    {
                      TranslationFile.FooterMicrosoftBusinessCentral[
                        userSelectedLanguage
                      ]
                    }
                  </center>
                </a>
              </li>
            </section>
          </center>
        </div>
        <div className="footer-list-div-1">
          <center>
            <div className="footer_title1">
              {TranslationFile.FooterFAQReferences[userSelectedLanguage]}
            </div>
            <section className="footerSection">
              {/* <ul className="footer--bottom__ul"> */}
              <li>
                <a
                  className="footer--bottom_sub"
                  // href="/termsandconditions"
                  href={config.corporatePage.url + "terms-of-usage"}
                  target="_blank"
                >
                  <center>
                    {TranslationFile.FooterTermsofUsage[userSelectedLanguage]}
                  </center>
                </a>
              </li>
              <li>
                <a
                  className="footer--bottom_sub"
                  href={config.corporatePage.url + "data-security"}
                  target="_blank"
                >
                  <center>
                    {TranslationFile.FooterDataSecurity[userSelectedLanguage]}
                  </center>
                </a>
              </li>
              <li>
                <a
                  className="footer--bottom_sub"
                  // href="/customer-references/"
                  href={config.corporatePage.url + "customer-references"}
                  target="_blank"
                >
                  <center>
                    {
                      TranslationFile.FooterProjectReferences[
                        userSelectedLanguage
                      ]
                    }
                  </center>
                </a>
              </li>
              <li>
                <a
                  className="footer--bottom_sub"
                  href={config.corporatePage.url + "for-investors"}
                  target="_blank"
                >
                  <center>
                    {" "}
                    {TranslationFile.FooterForInvestors[userSelectedLanguage]}
                  </center>
                </a>
              </li>
              <li>
                <a
                  className="footer--bottom_sub"
                  href={config.corporatePage.url + "credits"}
                  target="_blank"
                >
                  <center>
                    {TranslationFile.FooterCredits[userSelectedLanguage]}
                  </center>
                </a>
              </li>
              {/* </ul> */}
            </section>
          </center>
        </div>
        <div className="footer-list-div-1">
          <center>
            <div className="footer_title1">
              {TranslationFile.FooterAboutUs[userSelectedLanguage]}
            </div>
            <section className="footerSection">
              {/* <li>
                    <HashLink to="/about-us"
                    href={config.corporatePage.url + "about-us#why-rebelSkool"}
                    target="_blank">
                      <center>
                        {TranslationFile.FooterWeAreRBBL[userSelectedLanguage]}
                      </center>
                    </HashLink>
                  </li> */}

              <li>
                <a
                  className="footer--bottom_sub"
                  // href="/about-us/Why-RebelSkool"
                  href={config.corporatePage.url + "about-us"}
                  target="_blank"
                >
                  <center>
                    {TranslationFile.FooterWeAreRBBL[userSelectedLanguage]}
                  </center>
                </a>
              </li>

              {/* <ul className="footer--bottom__ul"> */}
              <li>
                <a
                  className="footer--bottom_sub"
                  // href="/about-us/Why-RebelSkool"
                  href={config.corporatePage.url + "about-us#why-rebelSkool"}
                  target="_blank"
                >
                  <center>
                    {TranslationFile.FooterwhyRBL[userSelectedLanguage]}
                  </center>
                </a>
              </li>
              <li>
                <a
                  className="footer--bottom_sub"
                  // href="/about-us/Price-Policy"
                  href={
                    config.corporatePage.url +
                    "about-us#RebelSkool-Price-Policy"
                  }
                  target="_blank"
                >
                  <center>
                    {TranslationFile.FooterRBLPricePolicy[userSelectedLanguage]}
                  </center>
                </a>
              </li>
              {/* </ul> */}
            </section>
          </center>
        </div>
        <div className="footer-list-div-1" style={{ borderRight: "none" }}>
          <center>
            <div className="footer_title1">
              {TranslationFile.ContactUsHeader[userSelectedLanguage]}
            </div>
            <div className="footer-li-style">
              <li
                style={{
                  listStyle: "none",
                  fontSize: "26px",
                  fontWeight: "600"
                }}
              >
                {" "}
                RebelSkool AB
              </li>
              <li style={{ listStyle: "none" }}>Bollvägen 11 A</li>
              <li style={{ listStyle: "none" }}>523 60 Gällstad</li>
              <li style={{ listStyle: "none" }}> Org.Nr.: 559015-5395</li>
              <li style={{ listStyle: "none" }}>
                {" "}
                {TranslationFile.FooterContactNumber[userSelectedLanguage]}
              </li>

              <li
                style={{
                  listStyle: "none"
                  // fontStyle: "italic",
                }}
              >
                <a
                  href="mailto:info@rebelskool.com"
                  id="footer_email_contact_text"
                >
                  info@rebelskool.com
                </a>
              </li>
              <li style={{ listStyle: "none" }}>Godkänt för F-skatt</li>
            </div>
            <br></br>

            <div>
              <p className="footer-subscription-text">
                <span>
                  {TranslationFile.FooterSubscribeText[userSelectedLanguage]}
                </span>
                <br></br>
                <span>
                  {TranslationFile.FooterSubscribeText2[userSelectedLanguage]}
                </span>
              </p>
              <div className="footer--searchbox-wrap">
                <form
                  onSubmit={handleSubmit}
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(2 ,1fr)"
                  }}
                >
                  <Toast
                    ref={toast}
                    position="bottom-right"
                    className="news-letter-toast"
                  />
                  <a
                    href="mailto:info@rebelskool.com"
                    onClick={(e) => e.preventDefault()}
                    style={{ display: "contents" }}
                  >
                    <input
                      type="email"
                      name="email"
                      placeholder={
                        TranslationFile.FooterEmailLabel[userSelectedLanguage]
                      }
                      className="newsletter-Email-User"
                      autoComplete="off"
                      required
                      onInvalid={(e) =>
                        e.target.setCustomValidity(
                          TranslationFile.PleaseEnterValidEmail[
                            userSelectedLanguage
                          ]
                        )
                      }
                      onInput={(e) => e.target.setCustomValidity("")}
                      value={newsLetterEmail}
                      onChange={(e) => setNewsLetterEmail(e.target.value)}
                    />
                  </a>
                  {isLoading ? (
                    <div className="loader"> </div>
                  ) : (
                    <Button
                      type="submit"
                      icon="pi pi-send"
                      outlined
                      className="news-button"
                    />
                  )}
                </form>
              </div>
            </div>
          </center>
        </div>
      </div>
      <div className="footer-black-bottom">
        <center>
          © RebelSkool enabling prosperITy AB, Gällstad | Utvecklar tjänster för
          småföretagarna sedan 2015
        </center>
      </div>
    </footer>
  );
}
